export default __webpack_public_path__ + "media/Compass_left.747b8f36b747ef3faaba480b25cb0abd.svg";